export default class Input {
  constructor() {
    this.input = document.querySelectorAll(".jsInput");
    this.init();
  }

  init() {
    let l = this.input.length;
    for (let i = 0; i < l; i++) {
      this.input[i].addEventListener("change", () => {
        this.input[i].value === ""
          ? this.input[i].parentElement.classList.remove("freeze")
          : this.input[i].parentElement.classList.add("freeze");
      });
    }
  }
}
